import React, { useState } from 'react';
import { Progress, ErrorPanel, Table } from '@backstage/core-components';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { EntityDialog } from './EntityDialog.esm.js';
import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import { catalogUnprocessedEntitiesApiRef } from '../api/index.esm.js';

const useStyles = makeStyles((theme) => ({
  successMessage: {
    background: theme.palette.infoBackground,
    color: theme.palette.infoText,
    padding: theme.spacing(2)
  }
}));
const PendingEntities = () => {
  const classes = useStyles();
  const unprocessedApi = useApi(catalogUnprocessedEntitiesApiRef);
  const {
    loading,
    error,
    value: data
  } = useAsync(async () => await unprocessedApi.pending());
  const [, setSelectedSearchTerm] = useState("");
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  }
  if (error) {
    return /* @__PURE__ */ React.createElement(ErrorPanel, { error });
  }
  const columns = [
    {
      title: /* @__PURE__ */ React.createElement(Typography, null, "entityRef"),
      sorting: true,
      field: "entity_ref",
      customFilterAndSearch: (query, row) => row.entity_ref.toLocaleUpperCase("en-US").includes(query.toLocaleUpperCase("en-US")),
      render: (rowData) => rowData.entity_ref
    },
    {
      title: /* @__PURE__ */ React.createElement(Typography, null, "Kind"),
      sorting: true,
      field: "kind",
      render: (rowData) => rowData.unprocessed_entity.kind
    },
    {
      title: /* @__PURE__ */ React.createElement(Typography, null, "Owner"),
      sorting: true,
      field: "unprocessed_entity.spec.owner",
      render: (rowData) => rowData.unprocessed_entity.spec?.owner || "unknown"
    },
    {
      title: /* @__PURE__ */ React.createElement(Typography, null, "Raw"),
      sorting: false,
      render: (rowData) => /* @__PURE__ */ React.createElement(EntityDialog, { entity: rowData })
    }
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Table,
    {
      options: { pageSize: 20 },
      columns,
      data: data?.entities || [],
      onSearchChange: (searchTerm) => setSelectedSearchTerm(searchTerm),
      emptyContent: /* @__PURE__ */ React.createElement(Typography, { className: classes.successMessage }, "No pending entities found")
    }
  ));
};

export { PendingEntities };
//# sourceMappingURL=PendingEntities.esm.js.map
